export type AnalysisStatus = 'success' | 'partial' | 'failed';
export type DocumentType = 'mda' | 'earnings';
export type VerdictType = 'Positive' | 'Negative' | 'Neutral' | 'Mixed';
export type SentimentType = 'Positive' | 'Negative' | 'Neutral' | 'Mixed';
export type ConfidenceType = 'High' | 'Medium' | 'Low';

export interface DocumentMetadata {
  pdf_url?: string;
  document_type?: string;
  fiscal_year?: string;
  fiscal_quarter?: string | null;
  source?: string;
  download_status?: string;
}

export interface OverallSummary {
  executive_summary: string;
  key_highlights: string[];
  recommendations: string[];
  risk_factors: string[];
}

export interface CommentarySection {
  title: string;
  summary: string;
  key_points: string[];
  verdict: VerdictType;
}

export interface FinancialMetrics {
  [key: string]: string;
}

export interface DocumentInsightsData {
  overall_summary?: OverallSummary;
  revenue_commentary?: CommentarySection;
  ebitda_commentary?: CommentarySection;
  asset_efficiency_commentary?: CommentarySection;
  industrial_performance_commentary?: CommentarySection;
  financial_metrics?: FinancialMetrics;
  sentiment?: SentimentType;
  extraction_confidence?: ConfidenceType;
}

export interface DocumentResult {
  status: string;
  document_type: DocumentType;
  metadata?: DocumentMetadata;
  insights?: DocumentInsightsData;
}

export interface DocumentInsightsResponse {
  status: AnalysisStatus;
  company_name: string;
  combined_summary?: string;
  mda?: DocumentResult;
  earnings?: DocumentResult;
}

export interface DocumentInsightsRequest {
  company_name: string;
  country: string;
  force_refresh: boolean;
}

export const LOADING_STAGES = [
  'Checking cached insights…',
  'Fetching latest filings…',
  'Downloading documents…',
  'Running AI extraction…',
  'Generating executive insights…',
  'Finalizing analysis…',
] as const;

export type LoadingStage = typeof LOADING_STAGES[number];
